export const LOGIN = 'LOGIN';
export const REGISTER = 'REGISTER';
export const AUTHERROR = 'AUTHERROR';
export const LOGOUT = 'LOGOUT';
